'use client';

import { c as _c } from "react/compiler-runtime";
import type { Address, ChainId } from '@morpho-org/blue-sdk';
import SectionErrorBoundary from '@/components/common/SectionErrorBoundary';
import { VaultYourPositionChartError } from './VaultYourPositionChart';
import VaultYourPositionChartClient from './VaultYourPositionChart/VaultYourPositionChart.client';
import { VaultYourTransactionsError } from './VaultYourTransactions/states';
import VaultYourTransactionsClient from './VaultYourTransactions/VaultYourTransactions.client';
export interface VaultYourPositionClientProps {
  vaultAddress: Address;
  chainId: ChainId;
}
const VaultYourPositionClient = t0 => {
  const $ = _c(11);
  const {
    vaultAddress,
    chainId
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <VaultYourPositionChartError />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== chainId || $[2] !== vaultAddress) {
    t2 = <SectionErrorBoundary fallback={t1}><VaultYourPositionChartClient vaultAddress={vaultAddress} chainId={chainId} /></SectionErrorBoundary>;
    $[1] = chainId;
    $[2] = vaultAddress;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <VaultYourTransactionsError />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== chainId || $[6] !== vaultAddress) {
    t4 = <SectionErrorBoundary fallback={t3}><VaultYourTransactionsClient address={vaultAddress} chainId={chainId} /></SectionErrorBoundary>;
    $[5] = chainId;
    $[6] = vaultAddress;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t2 || $[9] !== t4) {
    t5 = <div className="gap-lg sm:gap-xl flex flex-col">{t2}{t4}</div>;
    $[8] = t2;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};
export default VaultYourPositionClient;